/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductGroupDto } from '../../models/backend-product-group-dto';

export interface SalesGroupsList$Params {
  create_date?: string;
  name?: string;

  /**
   * A search term.
   */
  search?: string;
  variant?: number;
}

export function salesGroupsList(
  http: HttpClient,
  rootUrl: string,
  params?: SalesGroupsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendProductGroupDto>>> {
  const rb = new RequestBuilder(rootUrl, salesGroupsList.PATH, 'get');
  if (params) {
    rb.query('create_date', params.create_date, {});
    rb.query('name', params.name, {});
    rb.query('search', params.search, {});
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendProductGroupDto>>;
    }),
  );
}

salesGroupsList.PATH = '/api/sales/groups/';
